import React from 'react';
import { Calendar, Users, DollarSign, TrendingUp } from 'lucide-react';
import { AdminStats, RecentActivity } from '../types';

interface DashboardTabProps {
  stats: AdminStats;
}

const recentActivities: RecentActivity[] = [
  {
    id: '1',
    message: 'Nueva reserva: Silla de ruedas eléctrica elevable',
    time: 'Hace 2 horas',
    type: 'booking',
    badge: 'Reserva nueva',
    badgeColor: 'bg-green-100 text-green-800'
  },
  {
    id: '2',
    message: 'Equipo añadido: Bastón inteligente',
    time: 'Hace 5 horas',
    type: 'equipment',
    badge: 'Equipo añadido',
    badgeColor: 'bg-blue-100 text-blue-800'
  },
  {
    id: '3',
    message: 'Registro de usuario: juanfrainfo@email.com',
    time: 'Hace 1 día',
    type: 'user',
    badge: 'Usuario nuevo',
    badgeColor: 'bg-purple-100 text-purple-800'
  }
];

export const DashboardTab: React.FC<DashboardTabProps> = ({ stats }) => {
  return (
    <div className="space-y-8">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        <div className="p-6 bg-white rounded-lg shadow-sm">
          <div className="flex items-center">
            <div className="p-3 bg-blue-100 rounded-full">
              <Calendar className="text-blue-600" size={24} />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-500">Total de equipos</p>
              <p className="text-2xl font-bold text-gray-900">{stats.totalEquipment}</p>
            </div>
          </div>
        </div>

        <div className="p-6 bg-white rounded-lg shadow-sm">
          <div className="flex items-center">
            <div className="p-3 bg-green-100 rounded-full">
              <Users className="text-green-600" size={24} />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-500">Reservas activas</p>
              <p className="text-2xl font-bold text-gray-900">{stats.activeBookings}</p>
            </div>
          </div>
        </div>

        <div className="p-6 bg-white rounded-lg shadow-sm">
          <div className="flex items-center">
            <div className="p-3 bg-yellow-100 rounded-full">
              <DollarSign className="text-yellow-600" size={24} />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-500">Ingresos totales</p>
              <p className="text-2xl font-bold text-gray-900">${stats.totalRevenue.toLocaleString()}</p>
            </div>
          </div>
        </div>

        <div className="p-6 bg-white rounded-lg shadow-sm">
          <div className="flex items-center">
            <div className="p-3 bg-purple-100 rounded-full">
              <TrendingUp className="text-purple-600" size={24} />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-500">Nuevos usuarios</p>
              <p className="text-2xl font-bold text-gray-900">{stats.newUsers}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="p-6 bg-white rounded-lg shadow-sm">
  <h2 className="mb-4 text-lg font-semibold">Actividad reciente</h2>
        <div className="space-y-4">
          {recentActivities.map((activity, index) => (
            <div
              key={activity.id}
              className={`flex items-center justify-between py-3 ${
                index < recentActivities.length - 1 ? 'border-b border-gray-200' : ''
              }`}
            >
              <div>
                <p className="font-medium text-gray-900">{activity.message}</p>
                <p className="text-sm text-gray-500">{activity.time}</p>
              </div>
              <span className={`px-2 py-1 text-xs rounded-full ${activity.badgeColor}`}>
                {activity.badge}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
